const f = {
    CustomEvent: "ce",
    Pr: "p",
    jd: "pc",
    ev: "ca",
    Fl: "i",
    wl: "ie",
    Xt: "cci",
    Zt: "ccic",
    Lt: "ccc",
    Qt: "ccd",
    Sm: "ss",
    hm: "se",
    wn: "si",
    zn: "sc",
    Sn: "sbc",
    tv: "sfe",
    om: "iec",
    yd: "lr",
    kd: "uae",
    Dd: "lcaa",
    Ad: "lcar",
    Zu: "inc",
    Qu: "add",
    Xu: "rem",
    Yu: "set",
    Vu: "ncam",
    $d: "sgu",
    xo: "ffi",
    ro: "bi",
    ut: "bc",
  },
  Ee = { nv: "content_cards_displayed" };
export { f as EventTypes, Ee as InternalEventTypes };
